<div class="mc-page mc-page-full mc-page-centered">
  <div role="img" aria-label="Logo" title="Logo" class="mc-portal-output-app-logo" i18n-aria-label="The aria label for the page's logo" i18n-title="The title tooltip for the page's logo"></div>
  <router-outlet></router-outlet>
</div>
